var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['main-navbar', 'bg-white', _vm.stickyTop ? 'sticky-top' : '']},[_c('d-navbar',{staticClass:"align-items-stretch flex-md-nowrap p-0"},[_c('navbar-search'),_c('navbar-nav')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }